import React, { useState, useEffect, useMemo } from "react";
import eventClasses from "./preferencegroups.module.scss";
import classes from "../../controls.module.scss"
import {
    FormControlLabel,
    FormControl,
    TextField,
    Button,
    Grid,
    Modal,
    Box
} from '@mui/material';
import { AddPlusIcon } from "../../../../Resources/availabilityicon/IconUtils";
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import useToggle from "@genesis/ui-kit/dist/hooks/useToggle";
import { useLocation } from "react-router-dom";
import NotificationView from "../../../../Shared/Notification/NotificationView";
import { useNavigate, NavLink } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "../../DivisionDropdown/DivisionDropdownComp";
import duplicate from "../../../../Resources/duplicate.png";
import deleteimg from "../../../../Resources/delete.png";
import add_disable from "../../../../Resources/add_disable.png";
import duplicate_disable from "../../../../Resources/duplicate_disable.png";
import delete_disable from "../../../../Resources/delete_disable.png";
import DeleteEventDialog from "./DeleteEventDialog";
import DuplicateEventDialog from "./DuplicateEventDialog";
import { AllControlSearchView } from "../RuleAssignments/Search/RuleAssignmentsSearch";
import NoOfDays from "./NoOfDays";
import DailyShiftHours from "./DailyShiftHours";
import WeeklyHours from "./WeeklyHours";
import { isString } from '../../../../Shared/Utill/Utills';
import { isEmpty } from "underscore";



const AddEditPreferenceGrouping = (props) => {

    console.log("LOOKIHERE2 " + JSON.stringify((props.currentRow.currentRow))); 
    //props.apiRef.current.toggleDetailPanel(1) 
    console.log("I THINK I GOT THIS" + JSON.stringify(props.data[props.apiRef.current.getExpandedDetailPanels()-1]));  
    const prefParams = props.currentRow.currentRow;
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const token = Cookie.get('X_TKN');
    const dialog = useToggle();
    const location = useLocation();
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const [division, setDivision] = React.useState(String(prefParams.divNbr));
    const [preferredGroup, setPreferredGroup] = React.useState(String(prefParams.pwhNbr));
    const [eventId, setEventId] = React.useState("");
    const [preferredLocation, setPreferredLocation] = React.useState(String(prefParams.locNbr));
    console.log("data from search parent!"+ JSON.stringify(location.state.data))
    const [eventBaseData, setEventBaseData] = React.useState(location.state.data);
    const [flag, setFlag] = React.useState(location.state.flag);
    const history = useNavigate();
    const [prefApiData, setprefApiData] = React.useState(null);
    const { message, severity, open } = isAlertOpen || {};
    const [readOnlyView, setReadOnly] = React.useState(false);
    const [ongoingActionCompleted, setOngoingActionCompleted] = React.useState(true);
    const [activateEvent, setActivateEvent] = React.useState(true)
    const [useBaseData, setUseBaseData] = useState(true);
    const [useApiData, setUseApiData] = useState(true);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);
    const [startHours, setStartHours] = React.useState({})
    const [endHours, setEndHours] = React.useState({})
    const [startHours2, setStartHours2] = React.useState({})
    const [endHours2, setEndHours2] = React.useState({})
    const [startHours3, setStartHours3] = React.useState({})
    const [endHours3, setEndHours3] = React.useState({})
    const [nbrOfDays,setNbrOfDays] = React.useState(null)
    const [weeklyHours,setWeeklyHours] = React.useState(null)
    const [shiftHours,setShiftHours] = React.useState(null)


   console.log("Checking for a pulse " + JSON.stringify(endHours3))

    // Modal 
    const [open2, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '70%',
        overflow:'scroll',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
    };
    const style2 = {   
        position:'absolute',   
        overflow:'scroll',
        height:'100%'
        
    };

    // Add
    const [eventName, setEventName] = React.useState("");
    //cancel editing
    const [cancelFlag, setCancelFlag] = React.useState(false);

    useEffect(() => {
        if ((eventBaseData !== null) && (eventBaseData !== undefined)) {
            console.log(flag);
            console.log("what data do i have", location.state.data);
            setUseBaseData(true);
            if (flag === 'E' || flag === 'C') {
                setReadOnly(true);
                if (useBaseData && ongoingActionCompleted) {
                    //setEventName(eventBaseData.eventname)
                    setDivision(eventBaseData.divnbr)
                    setPreferredLocation(eventBaseData.prefLocation)
                    setPreferredGroup(eventBaseData.pwhgrpnbr)
                }
            }

            //getEventDetailsApi(); 
        } else if (!useApiData) {
            console.log(flag)
            // set flag to A
            setFlag("A");
            setUseBaseData(false);
            setReadOnly(false);
            setOngoingActionCompleted(false);
            //setprefApiData(null)
        }

    }, [nbrOfDays, eventBaseData,prefParams]);


    useEffect(() => {
        //alert("we will finish this bs "+ props.flag + " " + ongoingActionCompleted)
        if ((flag === "E" || (flag === "C")) && ( nbrOfDays == undefined)) {
            setUseBaseData(false)
        }

        if ((props.flag === "E")||(flag === "E") || (flag === "C") && (nbrOfDays == null) && (ongoingActionCompleted)) {
            
            getPreferencesApi(division, preferredLocation,preferredGroup)
        }

    }, [flag]);

    //number validation
    const checkForNumber = (input) => {
        if (typeof input === "number") {
            return true;
        } else {
            return false;
        }

    }

    const resetForAdd = () => {
        if (ongoingActionCompleted) {
            console.log("SETUP FOR ADD")
            setEndHours3({})
            setStartHours3({})
            setEndHours2({})
            setStartHours2({})
            setEndHours({})
            setStartHours({})
            setOpenDuplicateDialog(false)
            setOpenDeleteDialog(false)
            setUseApiData(true)
            setUseBaseData(false)
            setActivateEvent(true)
            setOngoingActionCompleted(false)
            setReadOnly(false)
            setprefApiData(null)
            setNbrOfDays(null)
            setWeeklyHours(null)
            setShiftHours(null)
            setFlag("A")
        } else {
            console.log("not ready to click add")
        }


    }

    const handleChange = (event) => {
        setEventName(event.target.value)
    };

    const cancelEditing = () => {
        if(cancelFlag) {
            setCancelFlag(false)
        } else {
            setCancelFlag(true)
        }
        
        setOngoingActionCompleted(true);
        // call api to reset values
        
        makeReadOnly();
        
    }

    const makeEditable = () => {
        setReadOnly(false)
        setOngoingActionCompleted(false);
        
        console.log(readOnlyView + " ready only ")
        if (readOnlyView == true) {
            setReadOnly(false)
        }
    }
    const makeReadOnly = () => {
        //on click of save
        setOngoingActionCompleted(true);
        if (readOnlyView == false) {
            setReadOnly(true)
        }
    }

    const changeActivateEvent = (e) => {
        setActivateEvent(e.target.checked)
    }

    const handleAlertNotifClose = () => {
        setAlertOpen({});
    };

    const updateWeeklyHours = (start, end) => {
        console.log("start3 in main page", start);
        console.log("end3 in main page", end);
        setStartHours3(start);
        setEndHours3(end);
    }
    const updateDailyShift = (start, end) => {
        console.log("start2 in main page", start);
        console.log("end2 in main page", end);
        setStartHours2(start);
        setEndHours2(end);
    }
    const updateNoOfDays = (start, end) => {
        console.log("start in main page", start);
        console.log("end in main page", end);
        setStartHours(start);
        setEndHours(end);
    }

    const Edit = () => {
        return (
            <div>
                <div className={eventClasses.eventpagemargin}>
                    <Grid container spacing={4} >
                        <Grid item xs={2}>
                            <div className={eventClasses.scheduledAreas}>  </div>
                        </Grid>
                        <Grid item xs={2}>

                        </Grid>
                        <Grid item xs={2} >

                        </Grid>
                        <Grid classes={eventClasses.MuiGrid} item xs={1.25} >
                            {!readOnlyView && (flag === "E" || flag === "C") && <span className={eventClasses.spanforedit}  onClick={cancelEditing} >Reset</span>}
                            {!readOnlyView && flag === "A" && <span className={eventClasses.spanforedit}  onClick={cancelEditing} >Reset</span>}
                        </Grid>
                        <Grid classes={eventClasses.MuiGrid} item xs={3} >
                            {readOnlyView ?
                                <Button sx={{ minWidth: "100%" }} onClick={makeEditable} >Edit</Button>
                                : <Button sx={{ minWidth: "100%" }} onClick={saveData} color="secondary" >Update</Button>}

                        </Grid>
                        <Grid item xs={2} >
                        </Grid>
                    </Grid>

                </div>
            </div>
        )
    }


    const handleCancel = () => history('/controls/availabilityapplicationcontrols/preferencegroups');

    const onDivDropDownSelect = (selectedDivision) => {
        // setDivSelectedValue(selectedDivision);
        if (selectedDivision !== null && selectedDivision !== undefined) {
            console.log(selectedDivision.divNbr);
            setDivision(selectedDivision.divNbr);
        }
    }

    const formatPreferences = (preferences) => {
        console.log("Time to format",preferences)
        let ddnbrdays = []
        let ddwklyhours = []
        let ddshifthrs = []
        preferences.map(obj=>{
            
            if(obj.ctlName.indexOf("ddnbrdays") > -1) {
               
                ddnbrdays.push(obj)
            }
            if(obj.ctlName.indexOf("ddwklyrs") > -1) {
               
                ddwklyhours.push(obj)
            }
            if(obj.ctlName.indexOf("ddshifthrs") > -1) {
               
                ddshifthrs.push(obj)
            }
           
        });
        setNbrOfDays(ddnbrdays)
        setWeeklyHours(ddwklyhours)
        setShiftHours(ddshifthrs)
       console.log("formatted")
       console.log(ddnbrdays)
       console.log(ddwklyhours)
       console.log(ddshifthrs)
        
    }

    const getPreferencesApi = async (div = null, loc = null, pwhGNbr = null) => {

        let data = {
            divNbr: div !== null ? div : eventBaseData.divnbr,
            locNbr: loc !== null ? loc : eventBaseData.loc,
            pwhGrpNbr: pwhGNbr != null ? pwhGNbr: prefParams.pwhNbr
        }
        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_WFM_APP_CONTROL_GET_PREFRENCE_GROUPS}`,
            data,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then((response) => {
                console.log("response is", response.data)
                
                setUseBaseData(false);
                setprefApiData(response.data);
                formatPreferences(response.data)
               
                //setEventName(response.data[0].eventName)
                //setEventId(response.data[0].eventId);
                //console.log(prefApiData[0])
                if (ongoingActionCompleted) {
                    setUseApiData(true);
                    
                }
            })
            .catch((error) => {
                if (error.message === 'Network Error') {
                    history("/somethingwentwrong", { state: `Please logout and try again ` })
                }

            })
    }

    const saveData = async (divnbr = null, locnbr = null, pwhgrpnbr = null, ) => {
        console.log("WE ARE TRYING TO SAVE HERE")
        if (division !== undefined && preferredLocation !== undefined && preferredGroup !== undefined) {
            
            if (division === null) {
                setAlertOpen({
                    open: true,
                    severity: "error",
                    message: "Please Select Division",
                })
            }
    
            if (isString(division)) {
                setAlertOpen({
                    open: true,
                    severity: "error",
                    message: "Division should be numeric.",
                })
    
            }
    
            if (isString(preferredLocation)) {
                setAlertOpen({
                    open: true,
                    severity: "error",
                    message: "Location should be numeric.",
                })
    
            }
            if (isString(preferredGroup)) {
                console.log(preferredGroup)
                setAlertOpen({
                    open: true,
                    severity: "error",
                    message: "Preference Group ID should be numeric.",
                })
    
            }

        }
        
        else {


            let len = Object.keys(startHours).length;
            let eventHours = [];
            for (let i = 1; i <= len; i++) {
                let tmp = {};
                tmp.valueOne = startHours[i];
                tmp.valueTwo = endHours[`end-${i}`]
                eventHours.push(tmp)
            }
            console.log(eventHours);

            let len2 = Object.keys(startHours2).length;
            let eventHours2 = [];
            for (let i = 1; i <= len2; i++) {
                let tmp = {};
                tmp.valueOne = startHours2[i];
                tmp.valueTwo = endHours2[`end-${i}`]
                eventHours2.push(tmp)
            }
            console.log(eventHours2);

            let len3 = Object.keys(startHours3).length;
            let eventHours3 = [];
            for (let i = 1; i <= len3; i++) {
                let tmp = {};
                tmp.valueOne = startHours3[i];
                tmp.valueTwo = endHours3[`end-${i}`]
                eventHours3.push(tmp)
            }
            console.log(eventHours3);
            // i need to check for the arrays to see if they are empty, if they are, prevent a save?

            if (flag === "E") {
                console.log("EDIT TEST")
                console.log(prefParams.pwhNbr)
                // The three loops are to check for empty input on each of the dropdown arrays for preferences
                for (let i = 0; i < eventHours.length; i ++ ) {
                        let val1NOD = eventHours[i].valueOne !== null ? eventHours[i].valueOne:"" 
                        let val2NOD = eventHours[i].valueTwo !== null ? eventHours[i].valueTwo:""
                    if ( (val1NOD.length < 1) || (val2NOD.length < 1)) {
                        
                        setAlertOpen({
                            open: true,
                            severity: "error",
                            message: "Cannot save without selections for the three categories",
                        })
                       return;
                    }
                }
                for (let i = 0; i < eventHours2.length; i ++ ) {
                    let val1DSH = eventHours2[i].valueOne !== null ? eventHours2[i].valueOne:"" 
                    let val2DSH = eventHours2[i].valueTwo !== null ? eventHours2[i].valueTwo:""

                    if ((val1DSH.length < 1) || (val2DSH.length < 1)) {
                        
                        setAlertOpen({
                            open: true,
                            severity: "error",
                            message: "Cannot save without selections for the three categories",
                        })
                       return;
                    }
                }
                for (let i = 0; i < eventHours3.length; i ++ ) {
                    let val1WH = eventHours3[i].valueOne !== null ? eventHours3[i].valueOne:"" 
                    let val2WH = eventHours3[i].valueTwo !== null ? eventHours3[i].valueTwo:""

                    if ((val1WH.length < 1) || (val2WH.length < 1)) {
                        //alert(JSON.stringify(eventHours3))
                        setAlertOpen({
                            open: true,
                            severity: "error",
                            message: "Cannot save without selections for the three categories",
                        })
                       return;
                    }
                }
                /*if ((eventHours[0].valueOne.length < 1) || (eventHours2[0].valueOne.length < 1) || (eventHours3[0].valueOne.length < 1)) {
                    alert(JSON.stringify(eventHours))
                    setAlertOpen({
                        open: true,
                        severity: "error",
                        message: "Cannot save without selections for the three categories",
                    })
                   return;
                } */
                    
                
                //console.log(prefApiData)
                //preferredGroup !== null ? preferredGroup:prefParams.pwhNbr
                let data = {
                    divNbr: division !== null ? division : eventBaseData.divnbr,
                    locNbr: preferredLocation !== null ? preferredLocation : eventBaseData.loc,
                    pwhGrpNbr: prefParams.pwhNbr || "12",
                    days: eventHours,
                    shiftHours: eventHours2,
                    weeklyHours: eventHours3,
                    lastUpdatedBy: personDetails.emplID,
                    edit: true
                }

                axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_PREFERENCE_GROUPS_ADMIN_UPDATE}`,
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token,
                        }
                    }).then((res) => {
                        // call api to fetch data     
                        console.log("WE ARE TRYING TO SAVE HERE EDIT")
                        setAlertOpen({
                            open: true,
                            severity: "success",
                            message: "Event saved successfully",
                        })
                        makeReadOnly();
                        getPreferencesApi(division, preferredLocation,preferredGroup)

                    }).catch((err) => {
                        setAlertOpen({
                            open: true,
                            severity: "error",
                            message: err.response.data.message,
                        })
                    });
                // end of edit save
            } else if (flag === "A") {
                console.log("WE ARE TRYING TO SAVE HERE ADD")
                console.log(division)
                let data = {
                    divNbr: division,
                    locNbr: preferredLocation,
                    pwhGrpNbr: preferredGroup,
                    days: eventHours,
                    shiftHours: eventHours2,
                    weeklyHours: eventHours3,
                    lastUpdatedBy: personDetails.emplID,
                    edit: false
                }

                axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_PREFERENCE_GROUPS_ADMIN_UPDATE}`,
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token,
                        }
                    }).then((res) => {
                        console.log("WE ARE TRYING TO SAVE HERE3")
                        console.log(res)
                        setAlertOpen({
                            open: true,
                            severity: "success",
                            message: "Event saved successfully",
                        })
                        
                        setReadOnly(true)
                        setOngoingActionCompleted(true)
                        setFlag("E")
                        setUseBaseData(false);
                        setEventBaseData(null);
                        
                        //setEventId(res.data.eventId)
                        //setDivision(res.data.divNbr)
                        //setEventName(res.data.eventName);

                    }).catch((err) => {
                        setAlertOpen({
                            open: true,
                            severity: "error",
                            message: err.response.data.message,
                        })


                    });
            }  // end of save for add  
        } // else end
    } // save end

    const onCloseDialog = () => {
        setOpenDeleteDialog(false);
        setOpenDuplicateDialog(false);

    }

    const onDeleteCallback = (responseType, message) => {
        onCloseDialog();
        //handle success / failue
        setAlertOpen({
            open: true,
            severity: responseType,
            message: message,
        });
        // refresh data
        if (responseType == 'success') {
            // navigate back to event search page
            history('/controls/specialeventscontrols/eventcontrols', { stateDelete: true });
        }
    }

    const onDuplicateCallback = (responseType, message, resp) => {
        onCloseDialog();
        //handle success / failue
        setAlertOpen({
            open: true,
            severity: responseType,
            message: message,
        });
        setFlag("E");
        setEventName(resp.eventName);
        setEventId(resp.eventId);
        //: refresh page data to load data
        // getPreferencesApi(division,resp.eventName); // not required to refresh

    }
    const onDeleteAction = () => {
        setOpenDeleteDialog(true);
    }

    const onDuplicateAction = () => {
        setOpenDuplicateDialog(true);
    }

    if (flag === "E") {
        return (

            <div className={classes.pagemargin}>
                <AllControlSearchView />
                <div style={{ width: "100%" }}>        
                </div>
                <div className={classes.searchbox}>
                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    ></SnackBar>

                    <Grid container spacing={4} rowSpacing={6}>
                        
                        <Grid key={4} item xs={2}>

                        </Grid>
                        <Grid key={5} item xs={2}>
                        </Grid>

                        
                    </Grid>
                    
                                { ((flag === "E" || flag === "A" || flag === "C") && nbrOfDays) &&
                                    <NoOfDays
                                        flag={flag}
                                        cancelFlag={cancelFlag}
                                        readOnlyView={readOnlyView}
                                        updateNoOfDays={updateNoOfDays}
                                        eventHours={nbrOfDays !== null ? nbrOfDays : []} />}
                        
                                { ((flag === "E" || flag === "A" || flag === "C") && shiftHours ) &&
                                    <DailyShiftHours
                                        flag={flag}
                                        cancelFlag={cancelFlag}
                                        readOnlyView={readOnlyView}
                                        updateDailyShift={updateDailyShift}
                                        eventHours={shiftHours !== null ? shiftHours : []} />}
                                    
                                { ((flag === "E" || flag === "A" || flag === "C") && weeklyHours) &&
                                    <WeeklyHours
                                        flag={flag}
                                        cancelFlag={cancelFlag}
                                        readOnlyView={readOnlyView}
                                        updateWeeklyHours={updateWeeklyHours}
                                        eventHours={weeklyHours !== null ? weeklyHours : []} />}
                                
                        
                    
                     { nbrOfDays && <Edit readOnlyView={readOnlyView} makeEditable={makeEditable} makeReadOnly={makeReadOnly} />}
                        
                  
                    <Grid container spacing={4} rowSpacing={6}>



                        <Grid item xs={12}></Grid>

                    </Grid>


                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    >

                    </SnackBar>
                    {openDeleteDialog && <DeleteEventDialog onCloseDialog={onCloseDialog} onDeleteCallback={onDeleteCallback} divNbr={division} />}
                    {openDuplicateDialog && <DuplicateEventDialog onCloseDialog={onCloseDialog} onDuplicateCallback={onDuplicateCallback} eventId={eventId} eventName={eventName} />}

                </div>

            </div>)

    }

    else if (flag === "A") {
        return (
            <div className={classes.pagemargin}>
                <AllControlSearchView />
                <div style={{ width: "100%" }}>

                </div>

                <div className={classes.searchbox}>
                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    ></SnackBar>

                    <Grid container spacing={4} rowSpacing={6}>
                    
                        <Grid key={4} item xs={2}>

                        </Grid>
                        <Grid key={5} item xs={2}>

                        </Grid>

                        <Grid key={6} item xs={12}></Grid>
                    </Grid>
                    {((prefApiData === null || flag === "A") && (flag === "E" || flag === "A" || flag === "C") && nbrOfDays) &&
                        <NoOfDays
                            flag={flag}
                            cancelFlag={cancelFlag}
                            readOnlyView={readOnlyView}
                            updateNoOfDays={updateNoOfDays}
                            eventHours={nbrOfDays !== null ? nbrOfDays : []} />}

                    {((prefApiData === null || flag === "A") && (flag === "E" || flag === "A" || flag === "C")  && shiftHours) &&
                        <DailyShiftHours
                            flag={flag}
                            cancelFlag={cancelFlag}
                            readOnlyView={readOnlyView}
                            updateDailyShift={updateDailyShift}
                            eventHours={shiftHours !== null ? shiftHours : []} />}
                    {((prefApiData === null || flag === "A") && (flag === "E" || flag === "A" || flag === "C") && weeklyHours ) &&
                        <WeeklyHours
                            flag={flag}
                            cancelFlag={cancelFlag}
                            readOnlyView={readOnlyView}
                            updateWeeklyHours={updateWeeklyHours}
                            eventHours={prefApiData !== null ? weeklyHours : []} />}

                    { <Edit readOnlyView={readOnlyView} makeEditable={makeEditable} makeReadOnly={makeReadOnly} />}
                    <Grid container spacing={4} rowSpacing={6}>
                        <Grid key={7} item xs={4}></Grid>
                        <Grid key={8} item xs={2}></Grid>

                        
                        <Grid item xs={12}></Grid>
                    </Grid>


                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    ></SnackBar>
                    {openDeleteDialog && <DeleteEventDialog onCloseDialog={onCloseDialog} onDeleteCallback={onDeleteCallback} divNbr={division} locNbr={preferredLocation} pwhGrpNbr={preferredGroup} />}
                    {openDuplicateDialog && <DuplicateEventDialog onCloseDialog={onCloseDialog} onDuplicateCallback={onDuplicateCallback} eventId={eventId} eventName={eventName} />}

                </div>

            </div>)
    }



}

export default AddEditPreferenceGrouping